import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import HorizontalOverflow from "../../../../modules/HorizontalOverflow";
import getClassNameFactory from "../../../../utilities/classNames";

var TabList = function TabList(_ref) {
  var _classNames;

  var children = _ref.children,
      layoutVariant = _ref.layoutVariant,
      horizontalTabsActions = _ref.horizontalTabsActions;
  var getClassName = getClassNameFactory("TabsTabList");
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: getClassName({
      modifiers: classNames((_classNames = {}, _defineProperty(_classNames, layoutVariant, layoutVariant), _defineProperty(_classNames, "horizontalTabsActions", horizontalTabsActions), _classNames))
    })
  }, /*#__PURE__*/React.createElement(HorizontalOverflow, null, /*#__PURE__*/React.createElement("ul", {
    role: "tablist",
    className: getClassName({
      descendantName: "list"
    })
  }, children), horizontalTabsActions && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "actions"
    })
  }, horizontalTabsActions)));
};

TabList.propTypes = {
  /**
   * The children of this `TabList`. Should be of type `Tab`
   */
  children: PropTypes.node,

  /**
   * Prop to render right-side components inside horizontal tabs row
   */
  horizontalTabsActions: PropTypes.node,

  /**
   * Optional modifier to switch layout variants
   */
  layoutVariant: PropTypes.oneOf(["verticalAtDesktop"])
};
TabList.displayName = "Tabs.TabList";
export default TabList;